import { render } from "./operation.vue?vue&type=template&id=223216af&scoped=true"
const script = {}

import "./operation.vue?vue&type=style&index=0&id=223216af&scoped=true&lang=css"

import exportComponent from "C:\\Users\\97813\\Desktop\\汇智衣\\sd_hq_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223216af"]])

export default __exports__